// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mud-check-report .sample-metadata {
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 4px;
}
.mud-check-report .sample-metadata .metadata-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}
.mud-check-report .sample-metadata .metadata-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mud-check-report .sample-metadata .metadata-item strong {
  font-size: 0.85rem;
  color: #555;
}
.mud-check-report .sample-metadata .metadata-item span {
  font-size: 0.95rem;
  font-weight: 500;
}
.mud-check-report .section {
  margin-bottom: 5px;
  page-break-inside: avoid;
}
.mud-check-report .section h3 {
  background: #ffffd9;
  border: 1px solid #333;
  padding: 2px 6px;
  margin: 0;
  color: #222;
  font-size: 8pt;
  font-weight: 600;
  text-align: center;
}
.mud-check-report .section p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
}
.mud-check-report .data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 7pt;
  margin-bottom: 0;
}
.mud-check-report .data-table thead {
  background: #f5f5f5;
  border-bottom: 2px solid #999;
}
.mud-check-report .data-table thead th {
  padding: 2px 3px;
  text-align: left;
  font-weight: 600;
  border: 1px solid #ccc;
  font-size: 7pt;
}
.mud-check-report .data-table tbody tr:nth-child(even) {
  background: #fafafa;
}
.mud-check-report .data-table tbody tr:hover {
  background: #f5f5f5;
}
.mud-check-report .data-table tbody td {
  padding: 2px 3px;
  border: 1px solid #555;
  vertical-align: top;
}
.mud-check-report .data-table tbody td.label {
  font-weight: 500;
  color: #333;
  width: 35%;
}
.mud-check-report .data-table tbody td.value {
  text-align: right;
  padding-right: 5px;
}
.mud-check-report .rheology-table thead th {
  padding: 2px;
  font-size: 6.5pt;
}
.mud-check-report .rheology-table tbody td {
  padding: 2px;
  text-align: center;
}
.mud-check-report .rheology-table tbody td:first-child {
  text-align: left;
}
.mud-check-report .api-salinity-table thead th {
  text-align: center;
}
.mud-check-report .api-salinity-table thead th:first-child {
  text-align: left;
}
.mud-check-report .api-salinity-table tbody td.label {
  width: auto;
  font-weight: 500;
}
.mud-check-report .api-salinity-table tbody td.value {
  text-align: right;
}
.mud-check-report .api-salinity-table tbody td.alert-label {
  color: #d71920;
}
.mud-check-report .particle-size-table th,
.mud-check-report .particle-size-table td {
  text-align: center;
  width: 25%;
}
.mud-check-report .custom-test-section .custom-report-subsection {
  margin: 0;
}
.mud-check-report .custom-test-section .custom-report-subsection h4 {
  margin: 0;
  padding: 2px 6px;
  border: 1px solid #ccc;
  border-top: 0;
  background: #f5f5f5;
  color: #333;
  font-size: 7pt;
  font-weight: 600;
}
.mud-check-report .custom-test-section .custom-report-table {
  margin: 0;
}
.mud-check-report .custom-test-section .custom-report-table tbody td {
  padding: 2px 3px;
}
.mud-check-report .custom-test-section .custom-report-table-section,
.mud-check-report .custom-test-section .custom-report-spreadsheet-section {
  margin-top: 4px;
}
.mud-check-report .custom-test-section .custom-report-table-scroll {
  overflow-x: auto;
}
.mud-check-report .custom-test-section .custom-table-report {
  min-width: 100%;
}
.mud-check-report .custom-test-section .custom-table-report th,
.mud-check-report .custom-test-section .custom-table-report td {
  border: 1px solid #555;
  padding: 2px 3px;
  white-space: nowrap;
}
.mud-check-report .custom-test-section .custom-table-report thead th,
.mud-check-report .custom-test-section .custom-table-report tbody th {
  background: #f5f5f5;
  font-weight: 600;
}
.mud-check-report .custom-test-section .custom-report-spreadsheet-grid {
  display: grid;
  grid-template-columns: repeat(var(--spreadsheet-columns), minmax(80px, 1fr));
  grid-auto-rows: minmax(20px, auto);
  min-width: 0;
  overflow-x: auto;
  border-left: 1px solid #555;
  border-top: 1px solid #555;
}
.mud-check-report .custom-test-section .custom-report-spreadsheet-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 20px;
  padding: 2px 3px;
  border-right: 1px solid #555;
  border-bottom: 1px solid #555;
  font-size: 7pt;
  overflow-wrap: anywhere;
}
.mud-check-report .custom-test-section .custom-report-spreadsheet-cell.has-definition {
  background: #fff;
}
.mud-check-report .custom-test-section .custom-report-spreadsheet-label {
  font-weight: 600;
  color: #333;
}
.mud-check-report .custom-test-section .custom-report-spreadsheet-value {
  display: block;
  width: 100%;
  text-align: right;
  color: #222;
}
.mud-check-report .particle-chart {
  margin-top: 3px;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
}
.mud-check-report .particle-chart svg {
  display: block;
  width: 100%;
  height: auto;
  max-height: 2.15in;
}
.mud-check-report .particle-chart .chart-axis {
  stroke: #222;
  stroke-width: 1.5;
}
.mud-check-report .particle-chart .chart-grid {
  stroke: #e1e1e1;
  stroke-width: 1;
}
.mud-check-report .particle-chart .secondary-axis {
  stroke: #aaa;
}
.mud-check-report .particle-chart .chart-bar {
  fill: #97bd61;
  stroke: #34442a;
  stroke-width: 1;
}
.mud-check-report .particle-chart .chart-line {
  fill: none;
  stroke: #111;
  stroke-width: 2.5;
  stroke-linejoin: round;
}
.mud-check-report .particle-chart .chart-point {
  fill: #fff;
  stroke: #111;
  stroke-width: 2;
}
.mud-check-report .particle-chart .chart-tick,
.mud-check-report .particle-chart .chart-x-tick,
.mud-check-report .particle-chart .chart-label {
  fill: #555;
  font-family: Arial, sans-serif;
  font-size: 11px;
  text-anchor: middle;
}
.mud-check-report .particle-chart .left-tick {
  text-anchor: end;
}
.mud-check-report .particle-chart .right-tick {
  text-anchor: start;
}
.mud-check-report .particle-chart .chart-x-tick {
  font-size: 8px;
  text-anchor: end;
}
.mud-check-report .particle-chart .chart-label {
  font-size: 13px;
}
.mud-check-report .particle-chart .y-label {
  transform: rotate(-90deg);
}
.mud-check-report .particle-chart .left-label {
  transform-origin: 20px 188px;
}
.mud-check-report .particle-chart .right-label {
  transform-origin: 880px 188px;
}
.mud-check-report .empty-state {
  text-align: center;
  padding: 24px;
  color: #999;
  font-size: 0.95rem;
}

@media print {
  .mud-check-report .section {
    page-break-inside: avoid;
  }
  .mud-check-report .data-table {
    page-break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/mud-check-report.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADN;AAGM;EACE,kBAAA;EACA,WAAA;AADR;AAIM;EACE,kBAAA;EACA,gBAAA;AAFR;AAOE;EACE,kBAAA;EACA,wBAAA;AALJ;AAOI;EACE,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AALN;AAQI;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AANN;AAUE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAUI;EACE,mBAAA;EACA,6BAAA;AARN;AAUM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AARR;AAcQ;EACE,mBAAA;AAZV;AAeQ;EACE,mBAAA;AAbV;AAiBM;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;AAfR;AAiBQ;EACE,gBAAA;EACA,WAAA;EACA,UAAA;AAfV;AAkBQ;EACE,iBAAA;EACA,kBAAA;AAhBV;AAuBI;EACE,YAAA;EACA,gBAAA;AArBN;AAwBI;EACE,YAAA;EACA,kBAAA;AAtBN;AAwBM;EACE,gBAAA;AAtBR;AA4BI;EACE,kBAAA;AA1BN;AA4BM;EACE,gBAAA;AA1BR;AA+BM;EACE,WAAA;EACA,gBAAA;AA7BR;AAgCM;EACE,iBAAA;AA9BR;AAiCM;EACE,cAAA;AA/BR;AAqCI;;EAEE,kBAAA;EACA,UAAA;AAnCN;AAwCI;EACE,SAAA;AAtCN;AAwCM;EACE,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAtCR;AA0CI;EACE,SAAA;AAxCN;AA0CM;EACE,gBAAA;AAxCR;AA4CI;;EAEE,eAAA;AA1CN;AA6CI;EACE,gBAAA;AA3CN;AA8CI;EACE,eAAA;AA5CN;AA8CM;;EAEE,sBAAA;EACA,gBAAA;EACA,mBAAA;AA5CR;AA+CM;;EAEE,mBAAA;EACA,gBAAA;AA7CR;AAiDI;EACE,aAAA;EACA,4EAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;AA/CN;AAkDI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,cAAA;EACA,uBAAA;AAhDN;AAkDM;EACE,gBAAA;AAhDR;AAoDI;EACE,gBAAA;EACA,WAAA;AAlDN;AAqDI;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AAnDN;AAuDE;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AArDJ;AAuDI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AArDN;AAwDI;EACE,YAAA;EACA,iBAAA;AAtDN;AAyDI;EACE,eAAA;EACA,eAAA;AAvDN;AA0DI;EACE,YAAA;AAxDN;AA2DI;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAzDN;AA4DI;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AA1DN;AA6DI;EACE,UAAA;EACA,YAAA;EACA,eAAA;AA3DN;AA8DI;;;EAGE,UAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AA5DN;AA+DI;EACE,gBAAA;AA7DN;AAgEI;EACE,kBAAA;AA9DN;AAiEI;EACE,cAAA;EACA,gBAAA;AA/DN;AAkEI;EACE,eAAA;AAhEN;AAmEI;EACE,yBAAA;AAjEN;AAoEI;EACE,4BAAA;AAlEN;AAqEI;EACE,6BAAA;AAnEN;AAuEE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AArEJ;;AAyEA;EAEI;IACE,wBAAA;EAvEJ;EA0EE;IACE,wBAAA;EAxEJ;AACF","sourcesContent":[".mud-check-report {\n  .sample-metadata {\n    background: #f9f9f9;\n    border: 1px solid #ddd;\n    padding: 12px;\n    margin-bottom: 16px;\n    border-radius: 4px;\n\n    .metadata-row {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 12px;\n    }\n\n    .metadata-item {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      strong {\n        font-size: 0.85rem;\n        color: #555;\n      }\n\n      span {\n        font-size: 0.95rem;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .section {\n    margin-bottom: 5px;\n    page-break-inside: avoid;\n\n    h3 {\n      background: #ffffd9;\n      border: 1px solid #333;\n      padding: 2px 6px;\n      margin: 0;\n      color: #222;\n      font-size: 8pt;\n      font-weight: 600;\n      text-align: center;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.9rem;\n      line-height: 1.5;\n    }\n  }\n\n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 7pt;\n    margin-bottom: 0;\n\n    thead {\n      background: #f5f5f5;\n      border-bottom: 2px solid #999;\n\n      th {\n        padding: 2px 3px;\n        text-align: left;\n        font-weight: 600;\n        border: 1px solid #ccc;\n        font-size: 7pt;\n      }\n    }\n\n    tbody {\n      tr {\n        &:nth-child(even) {\n          background: #fafafa;\n        }\n\n        &:hover {\n          background: #f5f5f5;\n        }\n      }\n\n      td {\n        padding: 2px 3px;\n        border: 1px solid #555;\n        vertical-align: top;\n\n        &.label {\n          font-weight: 500;\n          color: #333;\n          width: 35%;\n        }\n\n        &.value {\n          text-align: right;\n          padding-right: 5px;\n        }\n      }\n    }\n  }\n\n  .rheology-table {\n    thead th {\n      padding: 2px;\n      font-size: 6.5pt;\n    }\n\n    tbody td {\n      padding: 2px;\n      text-align: center;\n\n      &:first-child {\n        text-align: left;\n      }\n    }\n  }\n\n  .api-salinity-table {\n    thead th {\n      text-align: center;\n\n      &:first-child {\n        text-align: left;\n      }\n    }\n\n    tbody td {\n      &.label {\n        width: auto;\n        font-weight: 500;\n      }\n\n      &.value {\n        text-align: right;\n      }\n\n      &.alert-label {\n        color: #d71920;\n      }\n    }\n  }\n\n  .particle-size-table {\n    th,\n    td {\n      text-align: center;\n      width: 25%;\n    }\n  }\n\n  .custom-test-section {\n    .custom-report-subsection {\n      margin: 0;\n\n      h4 {\n        margin: 0;\n        padding: 2px 6px;\n        border: 1px solid #ccc;\n        border-top: 0;\n        background: #f5f5f5;\n        color: #333;\n        font-size: 7pt;\n        font-weight: 600;\n      }\n    }\n\n    .custom-report-table {\n      margin: 0;\n\n      tbody td {\n        padding: 2px 3px;\n      }\n    }\n\n    .custom-report-table-section,\n    .custom-report-spreadsheet-section {\n      margin-top: 4px;\n    }\n\n    .custom-report-table-scroll {\n      overflow-x: auto;\n    }\n\n    .custom-table-report {\n      min-width: 100%;\n\n      th,\n      td {\n        border: 1px solid #555;\n        padding: 2px 3px;\n        white-space: nowrap;\n      }\n\n      thead th,\n      tbody th {\n        background: #f5f5f5;\n        font-weight: 600;\n      }\n    }\n\n    .custom-report-spreadsheet-grid {\n      display: grid;\n      grid-template-columns: repeat(var(--spreadsheet-columns), minmax(80px, 1fr));\n      grid-auto-rows: minmax(20px, auto);\n      min-width: 0;\n      overflow-x: auto;\n      border-left: 1px solid #555;\n      border-top: 1px solid #555;\n    }\n\n    .custom-report-spreadsheet-cell {\n      display: flex;\n      align-items: center;\n      min-width: 0;\n      min-height: 20px;\n      padding: 2px 3px;\n      border-right: 1px solid #555;\n      border-bottom: 1px solid #555;\n      font-size: 7pt;\n      overflow-wrap: anywhere;\n\n      &.has-definition {\n        background: #fff;\n      }\n    }\n\n    .custom-report-spreadsheet-label {\n      font-weight: 600;\n      color: #333;\n    }\n\n    .custom-report-spreadsheet-value {\n      display: block;\n      width: 100%;\n      text-align: right;\n      color: #222;\n    }\n  }\n\n  .particle-chart {\n    margin-top: 3px;\n    border: 1px solid #ccc;\n    background: #fff;\n    border-radius: 4px;\n\n    svg {\n      display: block;\n      width: 100%;\n      height: auto;\n      max-height: 2.15in;\n    }\n\n    .chart-axis {\n      stroke: #222;\n      stroke-width: 1.5;\n    }\n\n    .chart-grid {\n      stroke: #e1e1e1;\n      stroke-width: 1;\n    }\n\n    .secondary-axis {\n      stroke: #aaa;\n    }\n\n    .chart-bar {\n      fill: #97bd61;\n      stroke: #34442a;\n      stroke-width: 1;\n    }\n\n    .chart-line {\n      fill: none;\n      stroke: #111;\n      stroke-width: 2.5;\n      stroke-linejoin: round;\n    }\n\n    .chart-point {\n      fill: #fff;\n      stroke: #111;\n      stroke-width: 2;\n    }\n\n    .chart-tick,\n    .chart-x-tick,\n    .chart-label {\n      fill: #555;\n      font-family: Arial, sans-serif;\n      font-size: 11px;\n      text-anchor: middle;\n    }\n\n    .left-tick {\n      text-anchor: end;\n    }\n\n    .right-tick {\n      text-anchor: start;\n    }\n\n    .chart-x-tick {\n      font-size: 8px;\n      text-anchor: end;\n    }\n\n    .chart-label {\n      font-size: 13px;\n    }\n\n    .y-label {\n      transform: rotate(-90deg);\n    }\n\n    .left-label {\n      transform-origin: 20px 188px;\n    }\n\n    .right-label {\n      transform-origin: 880px 188px;\n    }\n  }\n\n  .empty-state {\n    text-align: center;\n    padding: 24px;\n    color: #999;\n    font-size: 0.95rem;\n  }\n}\n\n@media print {\n  .mud-check-report {\n    .section {\n      page-break-inside: avoid;\n    }\n\n    .data-table {\n      page-break-inside: avoid;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
